<!-- TM-1000001468: Separated customer/contract (col-6) from documents (col-3) -->
<ng-container *ngIf="initialized">

    @if (ticketObjects && ticketObjects.length) {
        <div class="flex flex-column gap-3 pt-2">
            <div *ngIf="busy"
                 class="absolute top-0 left-0 w-full h-full flex flex-column align-items-center justify-content-center"
                 style="background-color: rgb(244 244 244 / 30%); z-index: 9999;">
                <p-progressSpinner styleClass="text-primary"></p-progressSpinner>
            </div>
            <!-- Non-document objects (Customer, Contract, etc.) in col-6 -->
            @if (nonDocumentObjects.length) {
                <div class="grid px-3">
                    @for (object of nonDocumentObjects; track object.id) {
                        <div class="col-6">
                            <div class="border-round-sm block flex flex-column p-1"
                                 style="background: var(--bluegray-50);"
                                 (contextmenu)="handleContextMenu(object, $event)"
                                 [ngStyle]="{'border-left': '4px solid var(--' + (object?.ticketTypeObjectRoleDto?.rgbaColor ?
                                     object.ticketTypeObjectRoleDto.rgbaColor : 'bluegray-50') + ')'}">

                                <mvs-object-inline
                                        [objectTypeId]="object.objectTypeDtoId"
                                        [objectId]="object.objectId"
                                        [importObjectContext]="importObjectContext"
                                        (onObjectSelect)="handleObjectSelect($event)"
                                ></mvs-object-inline>

                                <div class="flex align-items-center ml-2">
                                    @if (object.uiIsMainTicketObject) {
                                        *
                                    }

                                    @if (object.ticketTypeObjectRoleDto) {
                                        <div class="flex gap-2 ml-2 py-1">
                                            <i *ngIf="object.ticketTypeObjectRoleDto?.image"
                                               class="text-sm {{object.ticketTypeObjectRoleDto?.image}}  text-{{object.ticketTypeObjectRoleDto?.rgbaColor}}">
                                            </i>
                                            <span class="text-sm text-700 ellipses">{{ object.ticketTypeObjectRoleDto?.name }}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }

            <!-- Document objects in col-3 (separate grid for new line) -->
            @if (documentObjects.length) {
                <div class="grid px-3">
                    @for (object of documentObjects; track object.id) {
                        <div class="col-4">
                            <div class="border-round-sm block flex flex-column p-1"
                                 style="background: var(--bluegray-50);"
                                 (contextmenu)="handleContextMenu(object, $event)"
                                 [ngStyle]="{'border-left': '4px solid var(--' + (object?.ticketTypeObjectRoleDto?.rgbaColor ?
                                     object.ticketTypeObjectRoleDto.rgbaColor : 'bluegray-50') + ')'}">

                                <div class="flex flex-column gap-1 cursor-pointer"
                                     (click)="openDocumentInSidebar(object)">
                                    <div class="relative w-full" style="height: 120px;">
                                        <mvs-pdf-viewer
                                                [objectId]="object.objectId"
                                                [documentMimeType]="getDocumentMimeType(object.objectId)"
                                                [height]="120"
                                                class="w-full">
                                        </mvs-pdf-viewer>
                                        <div class="absolute top-0 left-0 w-full h-full" style="z-index: 1;"></div>
                                    </div>

                                    <div class="flex pt-2 gap-2">
                                        <i class="fa-regular fa-file text-primary"></i>
                                        <div class="flex flex-column">
                                            <span class="text-sm text-700 ellipses">{{ getDocumentDetails(object.objectId)?.dmDocumentTypeDtoName || object.objectTypeDtoName || 'Dokument' }}</span>
                                            @if (getDocumentDetails(object.objectId)?.createdDate) {
                                                <span class="text-xs text-color-secondary">{{ getDocumentDetails(object.objectId)?.createdDate | date:'dd.MM.yyyy' }}</span>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div class="flex align-items-center ml-2">
                                    @if (object.uiIsMainTicketObject) {
                                        *
                                    }

                                    @if (object.ticketTypeObjectRoleDto) {
                                        <div class="flex gap-2 ml-2">
                                            <i *ngIf="object.ticketTypeObjectRoleDto?.image"
                                               class="text-sm {{object.ticketTypeObjectRoleDto?.image}}  text-{{object.ticketTypeObjectRoleDto?.rgbaColor}}">
                                            </i>
                                            <span class="text-sm text-700 ellipses">{{ object.ticketTypeObjectRoleDto?.name }}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>

        <p-contextMenu #cm1 appendTo="body"
                       [model]="contextMenuItems">
        </p-contextMenu>
    }
</ng-container>
